import ArticleLayout from '@/components/feature/ArticleLayout';
import { superbuyArticle } from '@/mocks/article-data';
import ArticleSchema from '@/components/feature/ArticleSchema';

export default function SuperbuyArticle() {
  return (
    <>
      <ArticleSchema
        slug="superbuy-spreadsheet-guide"
        title="Superbuy Spreadsheet Complete Guide 2026"
        description="The complete Superbuy Spreadsheet guide for international shoppers. Learn about logistics integration, global shipping features, and how Superbuy Spreadsheet compares with Hipobuy, Kakobuy, CSSBuy and Oopbuy platforms."
        imageUrl="https://readdy.ai/api/search-image?query=Global%20logistics%20and%20international%20shipping%20theme%20with%20world%20map%20sketches%20packaging%20materials%20and%20shipping%20labels%20artistically%20arranged%20on%20warm%20wooden%20desk%2C%20soft%20morning%20light%20through%20window%2C%20organized%20travel%20and%20commerce%20aesthetic%2C%20navy%20cream%20and%20kraft%20brown%20color%20palette%2C%20sophisticated%20logistics%20editorial%20style&width=1920&height=800&seq=article-superbuy-hero-v2&orientation=landscape"
      />
      <ArticleLayout article={superbuyArticle} />
    </>
  );
}